import React, {Component} from 'react';
import Translate from '../layout/Translate';
import cookie from 'react-cookie';

export default class Subscribe extends Component {

  constructor(props) {
    super(props);
    this.state = {
      messageParams: {
        first_name: '',
        last_name: '',
        email: '',
        lang: this.props.user.lang,
        privacy: false
      }
    };
  }

  componentDidUpdate () {
    let actions = this.props.actions;
    if (this.props.user.subscribe && this.props.user.subscribe.promise) {
      this.props.user.subscribe.promise.json().then(function (result) {
        actions.setSubscribeResult(result);
      });
    }
  }

  send () {
    if (!this.props.load) {
      this.props.actions.subscribe(this.state.messageParams);
    }
  }

  changeInfo (field, e) {
    this.setState({
      messageParams: {
        ...this.state.messageParams,
        [field]: e.target.value
      }
    });
  }

  changeCheckbox(field, e) {
    this.setState({
      messageParams: {
        ...this.state.messageParams,
        [field]: !this.state.messageParams[field]
      }
    });
  }

  handleKeyPress (e) {
    if (e.key === 'Enter') {
      this.send();
    }
  }

  toggleModal () {
    this.props.actions.toggleSubscribe();
    cookie.save('subscribeHide', true, {path: '/', maxAge: 604800});
  }

  render () {
    let success = false;
    if (this.props.user.subscribe && this.props.user.subscribe.success) {
      success = true;
      cookie.save('subscribeComplete', true, {path: '/', maxAge: 10000000000});
    }

    let errors = {};

    return (
      <div className={"mailing " + (this.props.open ? 'mailing_active ' : '') + (success ? 'mailing_success' : '')}>
        <div className="mailing__content">
          <div className="mailing__text">
            <div className="mailing__text_relative">
              <div className="mailing__title"><Translate slug="subscribe__title"/></div>
              <Translate slug="subscribe__text"/>
            </div>

            <div className="mailing__close" onClick={this.toggleModal.bind(this)}></div>
          </div>
          <div className="mailing__form form">
            {success &&
              <div className="mailing__success">
                <Translate slug="subscribe__thank"/>
              </div>
            }
            {!success &&
              <div>
                <div className="mailing__row">
                  <label className="mailing__label"><Translate slug="subscribe__name"/></label>
                  <input className="mailing__input mailing__input_short" onChange={this.changeInfo.bind(this, 'first_name')}
                         onKeyPress={this.handleKeyPress.bind(this)}/>
                  <input className="mailing__input mailing__input_short" onChange={this.changeInfo.bind(this, 'last_name')}
                         onKeyPress={this.handleKeyPress.bind(this)}/>
                </div>
                <div className="mailing__row">
                  <label className="mailing__label"><Translate slug="subscribe__email"/>*</label>
                  <input type="email" className="mailing__input" onChange={this.changeInfo.bind(this, 'email')}
                         onKeyPress={this.handleKeyPress.bind(this)}/>
                </div>
                <div className="mailing__row">
                  <label className="conditions"><input className="checkbox" type="checkbox"
                                                       checked={this.state.messageParams.privacy}
                                                       onChange={this.changeCheckbox.bind(this, 'privacy')}/>
                    <span><Translate slug="custom__accept2"/> <a
                      href="/privacy" target="_blank"> <Translate slug="custom__privacy"/></a></span></label>
                </div>
                <input type="button" className={"mailing__submit " + ((this.props.load) ? "mailing__submit_progress" : "")}
                       value={this.props.translations["subscribe__submit"]} onClick={this.send.bind(this)}/>
              </div>
            }
          </div>
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/common/components/popups/Subscribe.js